import { ROLES } from '@/utils/constants';
export default {
  data() {
    return {
      selectedContract: '',
      financialPositionError: false,
      financialPositionLoading: false,
      paidLoading: false,
      lateLoading: false,
      toExpireLoading: false,
      totalsLoading: false,
      financialPositionData: {
        late: [],
        toExpire: [],
        paid: [],
        paidTotal: null,
        toExpireTotal: null,
        lateTotal: null,
        hasPayableLatePaymentSlips: false,
        baseDate: null,
      },
    };
  },
  methods: {
    async getFinancialPosition(contract, { getSlipsUrl = true } = {}) {
      if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
      if (this.selectedContract.id === contract.id) return;
      try {
        this.financialPositionLoading = true;
        this.financialPositionError = false;
        this.financialPositionData = {
          late: [],
          toExpire: [],
          paid: [],
          paidTotal: null,
          toExpireTotal: null,
          lateTotal: null,
          hasPayableLatePaymentSlips: false,
          baseDate: null,
        };

        this.selectedContract = contract;
        this.totalsLoading = true;
        this.paidLoading = true;
        this.lateLoading = true;
        this.toExpireLoading = true;
        const params = {
          contractId: contract.id,
          contractType: contract.type,
          productCode: this.selectedUnit.product.code,
          blockCode: this.selectedUnit.block.code,
          unitCode: this.selectedUnit.unit.code,
          getSlipsUrl: getSlipsUrl ? 1 : 0,
        };
        const promises = [];

        promises.push(
          this.requestService(process.env.FINANCIAL_POSITION_API_URL, 'GET', {
            params: { ...params, types: ['toExpire'] },
            localErrorHandling: true,
            retries: 0,
          }).then((res) => {
            if (res.contractId === this.selectedContract.id.toString()) {
              this.financialPositionData = {
                ...this.financialPositionData,
                ...res,
              };
              this.toExpireLoading = this.totalsLoading = false;
              return res;
            }
          })
        );

        promises.push(
          this.requestService(process.env.FINANCIAL_POSITION_API_URL, 'GET', {
            params: { ...params, types: ['late'] },
            localErrorHandling: true,
            retries: 0,
          }).then((res) => {
            if (res.contractId === this.selectedContract.id.toString()) {
              this.financialPositionData = {
                ...this.financialPositionData,
                ...res,
              };
              this.lateLoading = this.totalsLoading = false;
              return res;
            }
          })
        );

        promises.push(
          this.requestService(process.env.FINANCIAL_POSITION_API_URL, 'GET', {
            params: { ...params, types: ['paid'] },
            localErrorHandling: true,
            retries: 0,
          }).then((res) => {
            if (res.contractId === this.selectedContract.id.toString()) {
              this.financialPositionData = {
                ...this.financialPositionData,
                ...res,
              };
              this.paidLoading = this.totalsLoading = false;
              return res;
            }
          })
        );

        await Promise.all(promises);
        return this.financialPositionData;
      } catch (err) {
        this.financialPositionError = true;
      } finally {
        this.financialPositionLoading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/financialPosition.js